// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__3wvlM","Open":"SideDrawer__Open__3xsf8","Closed":"SideDrawer__Closed__2za3W","Logo":"SideDrawer__Logo__10IHv"};